// extracted by mini-css-extract-plugin
module.exports = {"background":"PrivacyPolicy_background__3-cK0","privacyContainer":"PrivacyPolicy_privacyContainer__e6acA","font":"PrivacyPolicy_font__2_4hQ"};